import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/config";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-[85] w-14 h-14 flex items-center justify-center bg-vermilion text-white shadow-[0_8px_32px_rgba(255,59,48,0.35)]"
  >
    <MessageCircle size={24} strokeWidth={1.5} />
  </motion.a>
);
